import React from 'react';

const NavLogo = () => {
  return (
    <a href={'/'} className={"logo-link"}>
      <svg className={'weft-svg'} id={'weft-mark-nav'} viewBox={'0 0 135.957 123.399'}>
        <path
          className={'w'}
          d={
            'M39.126,112.705h0.269l6.121-19.775h7.331l-9.416,29.662h-7.803l-5.381-19.573h-0.27l-5.381,19.573h-7.869L7.312,92.93h8.004l6.188,19.775h0.27l5.381-19.775h6.524L39.126,112.705z'
          }
        />
        <path
          className={'w'}
          d={
            'M84.259,112.906c-1.547,6.592-6.658,10.493-14.259,10.493c-9.147,0-15.739-5.852-15.739-15.201c0-9.35,6.658-16.076,15.537-16.076c9.686,0,14.663,6.726,14.663,14.797v2.893H62.197c0.27,4.372,3.699,7.466,8.071,7.466c3.969,0,6.322-1.682,7.466-5.045L84.259,112.906z M76.591,104.768c-0.269-3.43-2.354-6.726-6.86-6.726c-4.439,0-6.659,3.027-7.398,6.726H76.591z'
          }
        />
        <path
          className={'w'}
          d={
            'M87.488,98.58v-5.65h4.372v-2.488c0-6.928,4.17-11.031,10.828-11.031c5.381,0,8.677,2.556,9.955,7.265l-5.18,1.681c-0.672-1.883-1.95-3.161-4.035-3.161c-2.488,0-3.564,1.883-3.564,4.641v3.094h7.937v5.65h-7.937v24.012h-8.004V98.58H87.488z'
          }
        />
        <path
          className={'w'}
          d={
            'M116.276,98.58h-4.237v-4.775l2.018-0.336c2.893-0.471,3.699-1.95,4.372-4.708l0.941-4.036h4.91v8.206h8.071v5.65h-8.071v14.663c0,2.556,1.144,3.699,3.564,3.699c1.614,0,3.296-0.605,5.045-1.413v5.313c-2.152,1.614-4.574,2.556-8.206,2.556c-4.573,0-8.407-2.018-8.407-8.34V98.58z'
          }
        />
        <path
          className={'w'}
          d={
            'M121.427,0h-10.436c-0.184,8.52-0.435,13.87-0.981,21.701h10.338C120.994,12.218,121.012,6.321,121.427,0'
          }
        />
        <path
          className={'w'}
          d={
            'M119.014,41.905h-10.288c-1.569,10.522-4.239,13.955-8.929,14.219C89.414,56.71,91.895,0.469,72.098,0.104c-9.079,0.168-13.471,8.724-16.571,21.527h9.55c1.455-6.899,3.325-8.566,7.02-8.737c12.078,0.554,4.661,53.009,26.934,53.009C111.452,65.903,116.673,56.866,119.014,41.905'
          }
        />
        <path
          className={'w'}
          d={
            'M52.388,41.906C50.215,52,48.125,56.348,44.155,56.125C34.768,55.597,33.473,27.325,32.888,0H22.449c1.274,19.484-1.194,65.904,22.467,65.904c11.544,0,15.113-10.348,17.552-23.998H52.388z'
          }
        />
        <polygon
          className={'line-through'}
          points={'0,27.347 0,36.376 18.412,36.376 17.526,27.347 '}
        />
        <polygon
          className={'line-through'}
          points={'40.546,27.345 41.435,36.375 74.827,36.375 73.279,27.345 '}
        />
        <polygon
          className={'line-through'}
          points={'97.077,27.345 98.864,36.378 135.957,36.378 135.957,27.345 '}
        />
      </svg>
    </a>
  );
};

export default NavLogo;
